// app/api/verificationApi.ts
import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'https://api.taxi-yaounde.com/api';
// const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:4000/api'; // Fallback to localhost for development

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Get verified vehicles with filters
export const getVerifiedVehicles = async (filter: string = 'all', date?: string) => {
  try {
    const response = await api.get('/vehicles/verified/get', {
      params: { filter, date },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching verified vehicles:', error);
    throw error;
  }
};

// Get verification statistics
export const getVerificationStatistics = async (period: string = 'all', date?: string) => {
  try {
    const response = await api.get('/vehicles/verified/statistics', {
      params: { period, date },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching verification statistics:', error);
    throw error;
  }
};

// Get door number
export const generateDoorNumber = async (vehicleId: string) => {
  try {
    const response = await api.post(`/vehicles/${vehicleId}/generate-door-number`);
    return response.data;
  } catch (error) {
    console.error('Error generating door number:', error);
    throw error;
  }
};

// Download door sticker
export const downloadDoorSticker = async (vehicleId: string, size: string = 'standard') => {
  try {
    const response = await api.get(`/vehicles/${vehicleId}/door-sticker-pdf`, {
      params: { size },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading door sticker:', error);
    throw error;
  }
};